import { render, staticRenderFns } from "./NoListEntriesMessage.vue?vue&type=template&id=358d6d3a"
import script from "./NoListEntriesMessage.vue?vue&type=script&lang=ts"
export * from "./NoListEntriesMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports